const onClickWrappedTextButton = (event) => {
  event.currentTarget.parentElement.classList.add('wrapped-text--open');
};

document.querySelectorAll('.wrapped-text__button').forEach(($button) => {
  $button.addEventListener('click', onClickWrappedTextButton);
});
